import axios from 'axios'
import { REACT_APP_API } from '../../config'

export default async function hasPublicationActiveByStockId(stockId) {
    try {
        const url = new URL(`${REACT_APP_API}/publications/meli/hasPublicationActive`, window.location.href)
        url.searchParams.append('sales_channel', 'meli')
        url.searchParams.append('stock_id', stockId)

        const response = await axios.get(url.href)
        return response?.data?.hasPublicationActive
    } catch (error) {
        if (error?.response?.data?.message) error.message = error.response.data.message
        return Promise.reject(error)
    }
}
